import axios from 'axios';

import { env } from 'config';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/auth/2fa`;

const get = async (): Promise<{ secret: string; qr: string }> =>
  (await axios.get(url)).data;

const reset = apiUtils.withAxiosInstance<any, { secret: string; qr: string }>(
  async (axiosInstance) => (await axiosInstance.post(`${url}/reset`)).data,
);

const authenticate = async (token: string) =>
  (
    await axios.post(
      `${url}/authenticate`,
      { token },
      {
        withCredentials: true,
        headers: {
          Authorization: 'Bearer two-fa', // current strategy required any token, should be re-implemented
        },
      },
    )
  ).data;

const enable = async (token: string) =>
  (await axios.post(`${url}/enable`, { token })).data;

const disable = apiUtils.withAxiosInstance(
  async (axiosInstance) => (await axiosInstance.post(`${url}/disable`)).data,
);

const setupAndAuthenticate = async (token: string) =>
  (
    await axios.post(
      `${url}/setup-and-authenticate`,
      { token },
      {
        withCredentials: true,
        headers: {
          Authorization: 'Bearer two-fa',
        },
      },
    )
  ).data;

export const authTwoFAApi = {
  get,
  reset,
  authenticate,
  setupAndAuthenticate,
  enable,
  disable,
};
